import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { get } from 'lodash'
import parse from 'html-react-parser'
import { getErrorMapping } from '../../features/data'
import { cssVariables } from '../../styles'
import { Feedback } from './../rewards-ui/components/Feedback/Feedback'
import { useSupportEmail } from '../../hooks'

const Message = styled.div`
	margin-bottom: ${cssVariables.spacings.lg};
`

const ErrorMessage = ({ error, className, dismissable, onDismiss }) => {
	const { label: supportEmail } = useSupportEmail()

	if (!error) {
		return null
	}

	let message = `Oops! Something went wrong! Please try again later or contacts us at ${supportEmail}`

	if (error.errors || error.graphQLErrors) {
		const errorCode = get(error, 'errors.0.message', get(error, 'graphQLErrors.0.message', ''))
		message = getErrorMapping(errorCode, supportEmail)
	} else if (typeof error === 'string') {
		message = getErrorMapping(error, supportEmail) || error.toString()
	}

	return (
		<Feedback className={className} data-test-id="ErrorMessage" dismissable={dismissable} onDismiss={onDismiss}>
			{parse(message)}
		</Feedback>
	)
}

ErrorMessage.propTypes = {
	error: PropTypes.any,
}

export { ErrorMessage }
